import React, { memo } from "react";
import "./loader.css";

const Loader = ({ className }) => {
  return (
    <div
      className={`loader w-12 h-12 !border-b-transparent border-solid border-yellowgreen ${className}`}
    ></div>
  );
};

export default memo(Loader);
